import React, { useContext, useEffect, useState } from "react";
import { useTreatmentFeedback } from "./store";
import { FeedbackDate } from "./FeedbackTab";
import TreatmentFeedbackTable from "./TreatmentFeedbackTable";
import { Card, ProgressBar } from "react-bootstrap";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { useLocation, useNavigate } from "react-router-dom";

function TreatmentFeedbackComponent() {
  const {
    treatmentFeedback,
    treatmentLoading,
    fetchTreatmentFeedback,
    fetchTreatmentFeedbackRating,
    treatmentRatingData,
  } = useTreatmentFeedback();
  const { startDate, endDate } = useContext(FeedbackDate);
  const [page, newPage] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");
  const pageNumber = parseInt(searchParams.get("page"));
  const [searchCount, setSearchCount] = useState(0);

  useEffect(() => {
    fetchTreatmentFeedbackRating(startDate.valueOf(), endDate.valueOf());
  }, [startDate]);

  useEffect(() => {
    newPage(pageNumber);
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber) {
      fetchTreatmentFeedback(startDate.valueOf(), endDate.valueOf(), pageNumber);
    }
  }, [pageNumber, startDate]);

  useEffect(() => {
    setSearchCount(searchCount+1);
    if (page && pageNumber && searchCount) {
      navigate(`/feedback?tab=${tab}&page=${page}`);
    }
  }, [page]);

  return (
    <div>
      <div className="">
        <Card className={""}>
          <Card.Body>
            <Card.Title as="div">
              Treatment Feedback Count : {treatmentRatingData?.documentCount}
            </Card.Title>
            <Card.Text>
              <div className="d-flex flex-column">
                <div className="d-flex gap-1 align-items-center">
                  <div className="ms-4"> Getting Result : </div>
                  <div className="w-50">
                    <ProgressBar
                      animated={true}
                      now={
                        (+treatmentRatingData?.ratingCount?.Yes /
                          treatmentRatingData?.documentCount) *
                        100
                      }
                    />
                  </div>
                  <div>{treatmentRatingData?.ratingCount?.Yes}</div>
                </div>
                <div className="d-flex gap-1 align-items-center ">
                  <div className="ms-n1">Not Getting Result : </div>
                  <div className="w-50">
                    <ProgressBar
                      animated={true}
                      variant="warning"
                      now={
                        (+treatmentRatingData?.ratingCount?.No /
                          treatmentRatingData?.documentCount) *
                        100
                      }
                    />
                  </div>
                  <div>{treatmentRatingData?.ratingCount?.No}</div>
                </div>
              </div>
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div>
        <TreatmentFeedbackTable
          treatmentFeedback={treatmentFeedback?.feedbacks}
          isLoading={treatmentLoading}
        />
        <PaginationDiv
          newPage={newPage}
          paginationData={{ pageCount: treatmentFeedback?.totalPage || 1, page: page }}
        />
      </div>
    </div>
  );
}

export default TreatmentFeedbackComponent;
